module.exports = __webpack_public_path__ + "static/media/icon-check.10a5b071.svg";